import Component from '../abstracts/Component';
import RegisterLogic from '../logics/RegisterLogic';

export default class RegistrationComponent extends Component {

  get SELECTORS() {
    return {
      registerForm: "#registerForm" ,
      privacyBtn: 'input[id=privacy1]'
    };
  }


  get CSS_CLASSNAMES() {
    return {
      hide: "--hidden",
      error: "error",
    };
  }

  constructor(compEl) {
    super(compEl);
    // els
    this.privacyBtn = this.$component.querySelector(this.SELECTORS.privacyBtn);
    this.registerForm = this.$component.querySelector(this.SELECTORS.registerForm);
  }

  render() {
    // i want to call the component on the element i need
    this.RegisterLogic = new RegisterLogic(this);
    this.RegisterLogic.render();
  }

}
